"use strict";

exports.__esModule = true;
exports.LayoutSettingsContext = void 0;
var _Utils = require("../../../Utils");
var _LayoutSettingsController = require("./LayoutSettingsController");
/**
 * Provides settings about the layout to consumers.
 * For use with global settings that don't belong in each widget
 * @component
 */
var LayoutSettingsContext = exports.LayoutSettingsContext = (0, _Utils.createEnhancedContext)({
  propName: "layoutSettings",
  defaultController: _LayoutSettingsController.LayoutSettingsController
});